import { render, staticRenderFns } from "./ListItemOtherSpeciality.vue?vue&type=template&id=569efd36&"
import script from "./ListItemOtherSpeciality.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemOtherSpeciality.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569efd36')) {
      api.createRecord('569efd36', component.options)
    } else {
      api.reload('569efd36', component.options)
    }
    module.hot.accept("./ListItemOtherSpeciality.vue?vue&type=template&id=569efd36&", function () {
      api.rerender('569efd36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemOtherSpeciality/ListItemOtherSpeciality.vue"
export default component.exports